/**
 * Tracks pending agent.tool_exec open spans so MCP handlers can close them
 * immediately on completion (#151) without waiting for the next assistant turn.
 */

export interface PendingToolSpan {
  spanId: string;
  toolName: string;
  startMs: number;
  closed: boolean;
}

export class ToolExecSpanRegistry {
  private readonly pending: PendingToolSpan[] = [];

  register(span: Omit<PendingToolSpan, "closed">): void {
    this.pending.push({ ...span, closed: false });
  }

  /** Close the oldest still-open span for {@link toolName} (FIFO). */
  closeFirst(toolName: string): PendingToolSpan | undefined {
    const idx = this.pending.findIndex((s) => !s.closed && s.toolName === toolName);
    if (idx === -1) return undefined;
    this.pending[idx].closed = true;
    return this.pending[idx];
  }

  isClosed(spanId: string): boolean {
    const span = this.pending.find((s) => s.spanId === spanId);
    return span?.closed ?? false;
  }

  /** Return spans that are still open (for turn-boundary close). */
  getStillOpen(): PendingToolSpan[] {
    return this.pending.filter((s) => !s.closed);
  }
}
